"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostOpportunitiesResponseSchema = exports.OpportunityDataObjectSchema = exports.OpportunitiesRequestStatusSchema = void 0;
const zod_1 = require("zod");
const GoalDataSchema = zod_1.z.object({
    mappingId: zod_1.z.string(),
});
const ScopeSchema = zod_1.z.object({
    metricTypes: zod_1.z.array(zod_1.z.string()),
    goalData: GoalDataSchema,
});
const TimeIntervalSchema = zod_1.z.object({
    start: zod_1.z.string(),
    end: zod_1.z.string(),
});
const AuditObjectSchema = zod_1.z.object({
    reference_audience: zod_1.z.number(),
    conversion_audience: zod_1.z.number(),
    conversion_rate: zod_1.z.number(),
    reference_audience_percentage: zod_1.z.number(),
    max_conversions: zod_1.z.number(),
    max_conversions_smoothed: zod_1.z.number(),
    potential: zod_1.z.number(),
    potential_daily: zod_1.z.number(),
    potential_monthly: zod_1.z.number(),
});
const OpportunitiesObjectSchema = zod_1.z.record(zod_1.z.string() /* mappingGoalId  ex: '264389' */, zod_1.z.object({
    conversion_audience_t_c: zod_1.z.number(),
    conversion_rate_t_c: zod_1.z.number(),
    avg_conversion_rate_t_c: zod_1.z.number(),
    additional_conversion: zod_1.z.number(),
    additional_revenue: zod_1.z.number(),
}));
exports.OpportunitiesRequestStatusSchema = zod_1.z.union([
    zod_1.z.literal('SUCCESS'),
    zod_1.z.literal('FAILED'),
    zod_1.z.literal('PENDING'),
    zod_1.z.literal('PROCESSING'),
]);
exports.OpportunityDataObjectSchema = zod_1.z.record(zod_1.z.string() /* `{emotion:device}` ex: 'competition:all' */, zod_1.z.record(zod_1.z.string() /* `{metrdcId#1:metrdcId#2}` ex: '829623:264390' */, zod_1.z.object({
    audit: AuditObjectSchema.optional(),
    opportunities: OpportunitiesObjectSchema.optional(),
})));
exports.PostOpportunitiesResponseSchema = zod_1.z.object({
    status: exports.OpportunitiesRequestStatusSchema,
    processingTime: zod_1.z.string(),
    scope: ScopeSchema,
    timeIntervals: zod_1.z.array(TimeIntervalSchema),
    source: zod_1.z.string(),
    data: exports.OpportunityDataObjectSchema,
});
//# sourceMappingURL=schemas.js.map